module.exports = "\r\n<div style=\"height:100%; width: 100%;\">\r\n\t<canvas id=\"resultat-container\">\r\n\t\r\n\t</canvas>\t\r\n</div>\r\n"